import Vue from 'vue';
import { DirectiveBinding } from 'vue/types/options.d';
let clickInEvent: MouseEvent;
const nodeEventRecorder = new Map();
let startClick: MouseEvent;
const seed = 0;
document.addEventListener('mousedown', (e: MouseEvent) => {
  clickInEvent = e;
});
document.addEventListener('mouseup', e => {
  nodeEventRecorder.forEach(value => {
    value(e, clickInEvent);
  });
});
function isValidKey(key: any, vnode: Vue): key is keyof typeof vnode {
  return key in vnode;
}
function createHandler(el: Element, binding: DirectiveBinding, vnode: Vue.VNode) {
  return (mouseup: any, mousedown: any) => {
    if (
      !vnode ||
      !vnode.context ||
      !mouseup?.target ||
      !mousedown?.target ||
      el.contains(mouseup?.target) ||
      el.contains(mousedown?.target) ||
      el === mouseup?.target
    ) {
      return;
    }
    if (binding.expression && isValidKey(binding.expression, vnode.context) && vnode.context[binding.expression]) {
      vnode.context[binding.expression](mousedown?.target);
    } else if (typeof binding.value === 'function') {
      binding.value(mousedown?.target);
    } else {
      throw new Error('value should be a function');
    }
  };
}

/**
 * v-clickoutside
 * @desc 点击元素外面才会触发的事件
 * @example
 * ```vue
 * <div v-element-clickoutside="handleClose">
 * ```
 */
export default {
  bind(el: HTMLElement, binding: DirectiveBinding, vnode: Vue.VNode): void {
    nodeEventRecorder.set(el, createHandler(el, binding, vnode));
  },
  update(el: HTMLElement, binding: DirectiveBinding, vnode: Vue.VNode): void {
    nodeEventRecorder.set(el, createHandler(el, binding, vnode));
  },
  unbind(el: HTMLElement): void {
    nodeEventRecorder.delete(el);
  },
};
